import { range } from 'lodash'
import * as React from 'react'
import { HashFields, HiddenField, Label, Select, TextField } from 'react-rails-form-helpers'
import * as API from '../lib/api'

interface IProps {
  creditCard?: API.ICreditCard
  handleCancelAddNewCardClick: () => void
  allowCancelling: boolean
}

export class CreditCardForm extends React.Component<IProps, object> {
  public static defaultProps: IProps = {
    handleCancelAddNewCardClick: () => {},
    allowCancelling: false,
    creditCard: {
      card_number: '',
      cvv: '',
      exp_month: '',
      exp_year: '',
      first_name: '',
      last_name: '',
    },
  }

  public yearOptions() {
    const currentYear = new Date().getFullYear()
    const yearRange = range(currentYear, currentYear + 20)

    return (
      yearRange.map((year) => <option key={year} value={year}>{year}</option>)
    )
  }

  public render() {
    const { creditCard, allowCancelling, handleCancelAddNewCardClick } = this.props

    if (creditCard) {
      const {
        card_number: cardNumber,
        cvv,
        exp_month: expMonth,
        exp_year: expYear,
      } = creditCard

      return (
        <>
          <HashFields name={`credit_card`}>
            <div className="grid-x">
              <div className="cell small-full xlarge-26 xlarge-padded">
                <div className="grid-x">
                  <div className="cell small-full">
                    <Label htmlFor="card_number">Credit/Debit Card</Label>
                    <TextField
                      name="card_number"
                      autoComplete="cc-number"
                      required={true}
                      pattern="[0-9]{13,16}"
                      defaultValue={cardNumber}
                    />
                  </div>
                </div>
              </div>

              <div className="cell small-full xlarge-34 xlarge-padded">
                <div className="grid-x">
                  <div className="cell small-20 small-padded">
                    <Label htmlFor="exp_month">Exp Month</Label>
                    <Select name="exp_month" autoComplete="cc-exp-month" defaultValue={expMonth}>
                      <option value="1">01</option>
                      <option value="2">02</option>
                      <option value="3">03</option>
                      <option value="4">04</option>
                      <option value="5">05</option>
                      <option value="6">06</option>
                      <option value="7">07</option>
                      <option value="8">08</option>
                      <option value="9">09</option>
                      <option value="10">10</option>
                      <option value="11">11</option>
                      <option value="12">12</option>
                    </Select>
                  </div>

                  <div className="cell small-20 small-padded">
                    <Label htmlFor="exp_year">Exp Year</Label>
                    <Select name="exp_year" autoComplete="cc-exp-year" defaultValue={expYear}>
                      {this.yearOptions()}
                    </Select>
                  </div>

                  <div className="cell small-20 small-padded">
                    <Label htmlFor="cvv">CVV</Label>
                    <TextField name="cvv" autoComplete="cc-csc" required={true} defaultValue={cvv} />
                  </div>
                </div>
              </div>
            </div>
          </HashFields>

          <HiddenField name="payment_type" value="credit_card" />

          {allowCancelling ? <a onClick={() => handleCancelAddNewCardClick()}>Cancel</a> : null}
        </>
      )
    } else {
      return null
    }
  }
}
